"use client";
import { initialise } from "@asosteam/asos-web-secure-script-container";
import { useEffect } from "react";
import { CLIENT_SECURE_SCRIPT_CONTAINER_DOMAIN } from "@/constants";

const loadSecureScriptContainer = async () => {
  initialise({
    containerDomain: CLIENT_SECURE_SCRIPT_CONTAINER_DOMAIN,
  });
};

export const SecureScriptContainerClient = () => {
  useEffect(() => {
    loadSecureScriptContainer();
  }, []);

  return <></>;
};
